module.exports = __webpack_public_path__ + "img/trade-service-parts-display-cjdr.468bcf67.jpg";